<template>
  <section>
    <b-loading :is-full-page="true" v-model="loading" :can-cancel="true"></b-loading>

    <b-button tag="router-link" :to="{name: 'WhatsAppAccountsCreate'}">Создать</b-button>

    <hr/>

    <b-table :data="accounts"

             hoverable
             bordered

             narrowed
             paginated
    >
      <b-table-column field="name" label="Название" centered>
        <template v-slot="props">
          {{ props.row.name }}
        </template>
      </b-table-column>

      <b-table-column field="description" label="WebHook №" centered>
        <template v-slot="props">
          {{ props.row.webhookId }}
        </template>
      </b-table-column>

      <b-table-column field="edit" label="Действия" centered>
        <template v-slot="props">
          <div class="buttons">
            <b-button type="is-primary" icon-right="pencil-outline"
                      tag="router-link" :to="{ name: 'WhatsAppAccountsEdit', params: {id: props.row.id} }"

                      :disabled="loading"
            />

            <b-button type="is-primary" icon-right="delete"
                      @click="remove(props.row.id)"

                      :disabled="loading"
            />
          </div>
        </template>
      </b-table-column>

      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon
                  icon="emoticon-frown-outline"
                  size="is-large"
              />
            </p>
            <p>Аккаунты отсутствуют</p>
          </div>
        </section>
      </template>
    </b-table>
  </section>
</template>

<script>
import whatsappAccountsRepository from '../../repository/whatsappAccountsRepository';

export default {
  data () {
    return {
      loading: false,
      accounts: [],
    };
  },
  methods: {
    fetchData () {
      this.loading = true;

      return whatsappAccountsRepository.all()
      .then(({data}) => {
        this.accounts = data;
      })
      .then(() => this.$buefy.toast.open('Аккаунты загружены'))
      .catch(() => this.$buefy.toast.open('Ошибка при загрузке'))
      .finally(() => {
        this.loading = false;
      });
    },
    remove (id) {
      this.loading = true;

      whatsappAccountsRepository.delete(id)
      .then(() => this.$buefy.toast.open('Удалено'))
      .catch(({response}) => this.$buefy.toast.open({
        message: 'Ошибка при удалении: ' + response.data.error,
        type: 'is-danger',
      }))
      .then(() => this.fetchData())
      .finally(() => {
        this.loading = false;
      });
    },
  },
  mounted () {
    this.fetchData();
  },
};
</script>

<style scoped>

</style>
